import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "Is the 1% credit a loan I have to repay?",
    a: "No. It's a lender-funded credit incentive offered at PRMG's discretion — applied directly toward your qualifying closing costs. It is not a separate loan product and there is nothing to repay.",
  },
  {
    q: "Which loan programs qualify?",
    a: "The 1% lender credit is available on most FHA, VA and conventional loan programs but may not be used in conjunction with other loan programs and it's based on your loan amount. It applies whether you're purchasing a home or refinancing your current one.",
  },
  {
    q: "What if the credit is more than my closing costs?",
    a: "The credit is applied toward qualifying closing costs and cannot exceed your actual closing costs — no cash back is available.",
  },
  {
    q: "Is this a government program?",
    a: "No. Paramount Residential Mortgage Group, Inc. is not affiliated with, endorsed by, or acting on behalf of any government agency. It's simply our way of thanking Georgia's local heroes.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="border-t border-[#E2E8F0] bg-[#FAF8F5] pb-28 sm:pb-36">
      <div className="mx-auto max-w-4xl px-5 pt-24 sm:px-8">
        <Reveal className="mb-12">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-[#D97706]">Chapter 05 — Fine Print, Plainly</p>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-[#0B162C] sm:text-3xl lg:text-4xl">
            Questions, answered.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border-t border-[#E2E8F0]">
            {FAQS.map((f, i) => (
              <div key={f.q} data-testid={`faq-item-${i}`} className="border-b border-[#E2E8F0]">
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-6 py-6 text-left"
                >
                  <span className="font-display text-base font-bold text-[#0B162C] sm:text-lg">{f.q}</span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors duration-300 ${
                      open === i ? "bg-[#DC2626] text-white" : "bg-[#0B162C]/5 text-[#0B162C]"
                    }`}
                  >
                    <Plus size={16} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p data-testid={`faq-answer-${i}`} className="max-w-2xl pb-7 text-sm leading-relaxed text-slate-600 sm:text-base">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
